// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"400":"0768399e","460":"cd987641","580":"bb6741f3","825":"0d475a51"}[chunkId] + ".js";
};